import React from "react";
import "./Main.css";

const ArticleSection = () => {
  return (
    <div className="blogPage__article-section">
      <div className="blogPage__article-section-inner">
        <div className="blogPage__article-section-main">
          <p className="blogPage__past-client-notice">
            Past client project: marketing website for Vault Hill.
          </p>
          <p>
            Awa Digital designed and developed the first website for Vault Hill,
            a metaverse project. Our work included brand-aligned design, clear
            messaging for a complex product, and SEO to support their funding
            round.
          </p>
          <p className="vaulthill-links">
            <b>Website: </b>
            <a href="https://vaulthill.ai/" rel="noreferrer" target="_blank">
              https://vaulthill.ai/
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ArticleSection;
